/**
 * Barrel for the Help Center API contracts.
 *
 * Routes (server) import via `@excellent/ui/api/contracts/help` and call
 * `createRoute(help.articles.list, ...)`. Clients import the same way and
 * call `apiCall(help.articles.list, args)` or `useApi(help.articles.list, args)`.
 */

export { articles } from "./articles";
export { categories } from "./categories";
export { links } from "./links";
export { seed } from "./seed";

export {
  helpArticleRowSchema,
  helpCategoryRowSchema,
  helpExternalLinkRowSchema,
  helpSearchHitSchema,
  helpIdParams,
} from "./_shared";

import { articles } from "./articles";
import { categories } from "./categories";
import { links } from "./links";
import { seed } from "./seed";

/** Aggregate, mirroring the `crm.*` and `lens.*` shape. */
export const help = {
  articles,
  categories,
  links,
  seed,
};
